module.exports = __webpack_public_path__ + "media/swapnil_testimonial.c6818cb1.mp4";